
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 w-full bg-[#12121A] border-t border-[#FF007A]/20 shadow-lg"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-start gap-3 flex-1">
                <div className="w-10 h-10 bg-[#FF007A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-cookie-line text-xl text-[#FF007A]"></i>
                </div>
                <p className="text-sm text-[#F3F3F3]/80 leading-relaxed">
                  Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Al continuar navegando, aceptas nuestra{' '}
                  <a href="/politica-cookies" className="text-[#FF007A] hover:underline cursor-pointer">
                    política de cookies
                  </a>.
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <button
                  onClick={handleReject}
                  className="px-5 py-2.5 bg-transparent text-[#F3F3F3]/70 rounded-lg text-sm font-medium hover:bg-[#F3F3F3]/10 transition-all duration-200 border border-[#F3F3F3]/20 whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <button
                  onClick={handleAccept}
                  className="px-5 py-2.5 bg-[#FF007A] text-white rounded-lg text-sm font-medium hover:bg-[#FF4DA6] transition-all duration-200 shadow-lg hover:shadow-[#FF007A]/50 whitespace-nowrap cursor-pointer"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
